@if (formGroup() && model()) {
<div class="request">
    <div class="row method">
        <app-select [formGroup]="formGroup()!" [model]="model()!.method" [meta]="metaMethod"></app-select>
    </div>
    <div class="row">
        <app-text [formGroup]="formGroup()!" [model]="model()!.url" [meta]="metaUrl"></app-text>
    </div>
</div>
}
